import React from 'react';

const link = 'text-sm underline min-h-[44px] min-w-[44px] px-1 disabled:opacity-40';

/**
 * The pages taken so far, in order. Every page can be retaken or deleted; in multi-page mode (one invoice put together
 * from several photos) a page can also be moved up or down, because people photograph the pages in whatever order the
 * paper is lying in.
 */
export default function CapturePageList({ pages, busy, multiPage = false, onRetake, onDelete, onMove }) {
  if (!pages.length) return null;
  return (
    <ol className="space-y-2" data-testid="capture-pages">
      {pages.map((p, idx) => (
        <li key={p.id} data-testid={`capture-page-${idx + 1}`}
          className="flex flex-wrap items-center gap-x-3 gap-y-1 border border-surface-border rounded p-2">
          <img src={p.url} alt={`Page ${idx + 1}`} className="w-14 h-14 object-cover rounded" />
          <span className="text-sm text-ink-muted mr-auto">Page {idx + 1}</span>
          {multiPage && (
            <>
              <button type="button" className={link} data-testid={`move-up-${p.id}`} disabled={busy || idx === 0}
                aria-label={`Move page ${idx + 1} up`} onClick={() => onMove(p.id, -1)}>
                Up
              </button>
              <button type="button" className={link} data-testid={`move-down-${p.id}`}
                disabled={busy || idx === pages.length - 1} aria-label={`Move page ${idx + 1} down`}
                onClick={() => onMove(p.id, 1)}>
                Down
              </button>
            </>
          )}
          <button type="button" className={link} data-testid={`retake-${p.id}`} disabled={busy}
            onClick={() => onRetake(p.id)}>
            Retake
          </button>
          <button type="button" className={`${link} text-danger`} data-testid={`delete-${p.id}`} disabled={busy}
            onClick={() => onDelete(p.id)}>
            Delete
          </button>
        </li>
      ))}
    </ol>
  );
}
